<template>
  <v-layout align-start justify-start row wrap>
    <v-flex
      xs2
      sm2
      md2
      v-for="image in artwork.media"
      :key="image.id"
      :class="{ 'py-0': $vuetify.breakpoint.smAndDown }"
    >
      <v-hover>
        <v-img
          @click="onThubmnailClick(image)"
          :src="image.url"
          :height="thumbnailHeight"
          :srcset="image.srcset"
          :sizes="thumbnailHeight"
          slot-scope="{ hover }"
          ref="thumbnail"
          class="thumbnail"
          :class="{
            selected: selectedImage && selectedImage.id === image.id,
            'elevation-12 scale-down': hover,
          }"
        />
      </v-hover>
    </v-flex>
    <v-flex
      v-if="artwork.video_id"
      xs2
      sm2
      md2
      :class="{ 'py-0': $vuetify.breakpoint.smAndDown }"
    >
      <v-hover>
        <VideoThumbnail
          @click="onVideoIconClicked"
          slot-scope="{ hover }"
          ref="thumbnail"
          class="thumbnail"
          :artworkId="artwork.id"
          :videoId="artwork.video_id"
          :height="thumbnailHeight"
          :sizes="thumbnailHeight"
          :class="{
            selected: selectedVideo === artwork.video_id,
            'elevation-12 scale-down': hover,
          }"
        />
      </v-hover>
    </v-flex>
  </v-layout>
</template>

<script>
import VideoThumbnail from "@/views/Video/VideoThumbnail.vue";

export default {
  props: {
    artwork: { required: true },
  },

  components: {
    VideoThumbnail,
  },

  computed: {
    thumbnailHeight() {
      if (this.$vuetify.breakpoint.xsOnly) return "40px";
      else if (this.$vuetify.breakpoint.smOnly) return "80px";
      return "100px";
    },

    selectedImage() {
      if (this.selectedVideo) return null;

      const queryImg = this.$route.query.img;
      const pos = this.artwork.media.findIndex((m) => m.id === queryImg);
      if (pos !== -1) return this.artwork.media[pos];
      return this.artwork.media[0]; // By default show first image
    },

    selectedVideo() {
      return this.$route.query.video;
    },
  },
  methods: {
    onThubmnailClick(image) {
      if (this.selectedImage && image.id === this.selectedImage.id) return null;
      this.$router.push({ path: this.artwork.path, query: { img: image.id } });
    },

    onVideoIconClicked() {
      if (this.selectedVideo === this.artwork.video_id) return;
      this.$router.push({
        path: this.artwork.path,
        query: { video: this.artwork.video_id },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.thumbnail {
  cursor: pointer;
  transition: all 0.2s ease-in-out;

  &.selected {
    border: 2px solid var(--v-primary-base);
    opacity: 0.6;
    cursor: default;
  }
}
</style>
